// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var ModalFormLayout$ReactHooksTemplate = require("./ModalFormLayout.res.js");

function categoryFromString(str) {
  if (str === "quiz") {
    return "Quiz";
  } else {
    return "Normal";
  }
}

function decodeEditFields(json) {
  return {
          surveyName: Json_decode.field("name", Json_decode.string, json),
          category: categoryFromString(Json_decode.field("category", Json_decode.string, json))
        };
}

function encodeUpdatePayload(name, category) {
  var tmp;
  tmp = category === "Normal" ? "normal" : "quiz";
  return Json_encode.object_({
              hd: [
                "name",
                name
              ],
              tl: {
                hd: [
                  "category",
                  tmp
                ],
                tl: /* [] */0
              }
            });
}

var specialCharRegex = {
  hd: "<",
  tl: {
    hd: "!",
    tl: {
      hd: "=",
      tl: {
        hd: "+",
        tl: {
          hd: "-",
          tl: {
            hd: "@",
            tl: {
              hd: ">",
              tl: {
                hd: "?",
                tl: {
                  hd: "'",
                  tl: {
                    hd: "\"",
                    tl: {
                      hd: "$",
                      tl: {
                        hd: "#",
                        tl: {
                          hd: "%",
                          tl: {
                            hd: "^",
                            tl: {
                              hd: "*",
                              tl: {
                                hd: "(",
                                tl: {
                                  hd: ")",
                                  tl: {
                                    hd: "/",
                                    tl: {
                                      hd: ".",
                                      tl: {
                                        hd: "&",
                                        tl: {
                                          hd: ",",
                                          tl: {
                                            hd: ";",
                                            tl: {
                                              hd: "`",
                                              tl: {
                                                hd: "~",
                                                tl: /* [] */0
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

function containsInvalidChar(words) {
  return List.exists((function (word) {
                return List.exists((function (x) {
                              return word === x;
                            }), specialCharRegex);
              }), words);
}

function SurveyMetaEdit(props) {
  var onSaved = props.onSaved;
  var onClose = props.onClose;
  var surveyId = props.surveyId;
  var projectId = props.projectId;
  var match = React.useState(function (param) {
        return "Loading";
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        return false;
      });
  var setNameError = match$1[1];
  var nameError = match$1[0];
  var match$2 = React.useState(function (param) {
        return false;
      });
  var setSubmitting = match$2[1];
  var submitting = match$2[0];
  var match$3 = React.useState(function (param) {
        
      });
  var setSaveError = match$3[1];
  var saveError = match$3[0];
  React.useEffect((function (param) {
          Js_promise.$$catch((function (param) {
                  Curry._1(setState, (function (param) {
                          return "Error";
                        }));
                  return Promise.resolve();
                }), Js_promise.then_((function (fields) {
                      Curry._1(setState, (function (param) {
                              return {
                                      TAG: "Ready",
                                      _0: fields
                                    };
                            }));
                      return Promise.resolve();
                    }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/projects/" + String(projectId) + "/surveys/" + String(surveyId), (function (param) {
                          return Json_decode.field("survey", decodeEditFields, param);
                        }))));
        }), [surveyId]);
  var handleNameChange = function (e) {
    var name = e.target.value;
    var words = Belt_List.fromArray(Js_string.split("", name));
    Curry._1(setNameError, (function (param) {
            return containsInvalidChar(words);
          }));
    Curry._1(setState, (function (prev) {
            if (typeof prev !== "object") {
              return prev;
            } else {
              return {
                      TAG: "Ready",
                      _0: {
                        surveyName: name,
                        category: prev._0.category
                      }
                    };
            }
          }));
  };
  var handleCategoryToggle = function (param) {
    Curry._1(setState, (function (prev) {
            if (typeof prev !== "object") {
              return prev;
            }
            var fields = prev._0;
            var match = fields.category;
            var tmp;
            tmp = match === "Normal" ? "Quiz" : "Normal";
            return {
                    TAG: "Ready",
                    _0: {
                      surveyName: fields.surveyName,
                      category: tmp
                    }
                  };
          }));
  };
  var handleSave = function (param) {
    if (typeof state !== "object") {
      return ;
    }
    var fields = state._0;
    if (!(fields.surveyName !== "" && !nameError)) {
      return ;
    }
    Curry._1(setSubmitting, (function (param) {
            return true;
          }));
    Curry._1(setSaveError, (function (param) {
            
          }));
    var params = {};
    params["survey"] = encodeUpdatePayload(fields.surveyName, fields.category);
    Js_promise.$$catch((function (param) {
            Curry._1(setSubmitting, (function (param) {
                    return false;
                  }));
            Curry._1(setSaveError, (function (param) {
                    return "Failed to update survey. Please try again.";
                  }));
            return Promise.resolve();
          }), Js_promise.then_((function (response) {
                var status = Json_decode.field("status", (function (param) {
                        return Json_decode.withDefault("failed", Json_decode.string, param);
                      }), response);
                if (status === "success") {
                  Curry._1(setSubmitting, (function (param) {
                          return false;
                        }));
                  Curry._1(onSaved, undefined);
                } else {
                  Curry._1(setSubmitting, (function (param) {
                          return false;
                        }));
                  Curry._1(setSaveError, (function (param) {
                          return "Failed to update survey. Please try again.";
                        }));
                }
                return Promise.resolve();
              }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/projects/" + String(projectId) + "/surveys/" + String(surveyId) + "/update", params)));
  };
  var isQuizModeActive;
  isQuizModeActive = typeof state !== "object" || state._0.category === "Normal" ? false : true;
  var canSave;
  canSave = typeof state !== "object" ? false : state._0.surveyName !== "" && !nameError && !submitting;
  var surveyName;
  surveyName = typeof state !== "object" ? "" : state._0.surveyName;
  var tmp;
  tmp = typeof state !== "object" ? (
      state === "Loading" ? JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                      className: "h-6 w-6",
                      src: Image$ReactHooksTemplate.dashboardLoading
                    }),
                JsxRuntime.jsx("span", {
                      children: "Loading survey...",
                      className: "text-sm text-aurometalsaurus"
                    })
              ],
              className: "px-5 py-8 sm:px-6 flex items-center justify-center gap-3"
            }) : JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("p", {
                    children: "Unable to load survey details. Please close and try again.",
                    className: "text-sm text-red-600 text-center"
                  }),
              className: "px-5 py-8 sm:px-6"
            })
    ) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(ModalFormLayout$ReactHooksTemplate.SurveyFields.make, {
                  name: surveyName,
                  nameError: nameError,
                  isQuizModeActive: isQuizModeActive,
                  onNameChange: handleNameChange,
                  onCategoryToggle: handleCategoryToggle
                }),
            saveError !== undefined ? JsxRuntime.jsx("p", {
                    children: saveError,
                    className: "text-red-500 text-xs px-5 sm:px-6 -mt-2 pb-4 text-right"
                  }) : null
          ]
        });
  return JsxRuntime.jsx(ModalFormLayout$ReactHooksTemplate.Shell.make, {
              body: tmp,
              footer: JsxRuntime.jsx(ModalFormLayout$ReactHooksTemplate.make, {
                    onDiscard: (function (param) {
                        Curry._1(onClose, undefined);
                      }),
                    onPrimary: handleSave,
                    primaryLabel: submitting ? "Saving..." : "Save",
                    primaryDisabled: !canSave,
                    discardDisabled: submitting
                  })
            });
}

var make = SurveyMetaEdit;

exports.categoryFromString = categoryFromString;
exports.decodeEditFields = decodeEditFields;
exports.encodeUpdatePayload = encodeUpdatePayload;
exports.specialCharRegex = specialCharRegex;
exports.containsInvalidChar = containsInvalidChar;
exports.make = make;
/* react Not a pure module */
